import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../../constants';

export default StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  blank: {
    paddingVertical: 5,
  },
  button: {
    paddingVertical: 10,
    paddingHorizontal: 5,
  },
  option: {
    height: 2,
    width: 15,
    backgroundColor: PALETTE.primaryStrokeLine,
  },
  selectedOption: {
    backgroundColor: PALETTE.secondaryActive,
    shadowColor: PALETTE.secondaryActive,
    shadowOpacity: 0.75,
    shadowRadius: 3,
    shadowOffset: { width: 0, height: 0 },
  },
  circleWrapper: {
    flexDirection: 'row',
    height: 2,
    justifyContent: 'space-between',
    paddingHorizontal: 5,
    paddingVertical: 10,
    width: 23,
  },
  circle: {
    backgroundColor: PALETTE.primaryStrokeLine,
    borderRadius: 1,
    height: 2,
    width: 2,
  },
});
